import { FieldProps } from 'formik'
import { FormikToggle } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface ProvingDetailsNorschleifeValues {
  nordschleife: boolean
}

export const ProvingDetailsNordschleifeForm: React.FC<{
  notification?: boolean
}> = ({ notification }) => {
  const { t } = useTranslation()

  return (
    <FormStack>
      {notification && (
        <FieldStack>
          <Label>
            {t(
              'Achtung! Es sind mehrere Einträge ausgewählt! Die Werte werden bei allen ausgewählten Einträgen mit den Werten aus der Formularmaske überschrieben!'
            )}
          </Label>
        </FieldStack>
      )}
      <Label>{t('Nordschleife')}</Label>
      <FieldStack>
        <FieldStackItem
          name="nordschleife"
          render={(fieldProps: FieldProps<ProvingDetailsNorschleifeValues>) => {
            return (
              <FormikToggle
                label={t('Fahrer Nordschleife benötigt')}
                inlineLabel={true}
                {...fieldProps}
              />
            )
          }}
        />
      </FieldStack>
    </FormStack>
  )
}
